export const GET_COMPONENTS_REQUEST = "GET_COMPONENTS_REQUEST";
export const GET_COMPONENTS_SUCCESS = "GET_COMPONENTS_SUCCESS";
export const GET_COMPONENTS_FAILURE = "GET_COMPONENTS_FAILURE";



export const EDIT_COMPONENTS_REQUEST = "EDIT_COMPONENTS_REQUEST";
export const EDIT_COMPONENTS_SUCCESS = "EDIT_COMPONENTS_SUCCESS";
export const EDIT_COMPONENTS_FAILURE = "EDIT_COMPONENTS_FAILURE";

export const CREATE_COMPONENTS_REQUEST = "CREATE_COMPONENTS_REQUEST";
export const CREATE_COMPONENTS_SUCCESS = "CREATE_COMPONENTS_SUCCESS";
export const CREATE_COMPONENTS_FAILURE = "CREATE_COMPONENTS_FAILURE";

export const DELETE_COMPONENTS_REQUEST = "DELETE_COMPONENTS_REQUEST";
export const DELETE_COMPONENTS_SUCCESS = "DELETE_COMPONENTS_SUCCESS";
export const DELETE_COMPONENTS_FAILURE = "DELETE_COMPONENTS_FAILURE";
